import React from "react";
// css
import "./GetInspireCard.css";

// GetInspireCard Home page only
const GetInspireCard = (props) => {
  return (
    <>
      <div className="get_inspire_card">
        <div className="gi_top">
          <img src={props.img} alt="..." />
        </div>
        <div className="gi_content">
          <h2>{props.title}</h2>
          <p>
            {props.text}
            <strong> Read more</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default GetInspireCard;
